// ActionButton component for various actions in the chat interface

import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { Hidden } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import ImageIcon from '@mui/icons-material/Image';
import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';

export default function ActionButton(props) {
  // Destructure props
  const { text, color, disabled, onClick, variant, sx, buttonKey, isClicked } = props;
  const { t } = useTranslation();

  // Handle button click
  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
    }
  };

  const renderIcon = (buttonKey) => {
    switch (buttonKey) {
      case 'send':
        return <SendIcon />;
      case 'upload':
        return <ImageIcon />;
      case 'record':
        return <MicIcon />;
      case 'stopRecord':
        return <MicOffIcon />;
      default:
        return null;
    }
  };

  return (
    <>
      {/* Button for larger screens */}
      <Hidden smDown>
        <Button
          variant={variant}
          color={color}
          disabled={disabled}
          onClick={handleClick}
          data-testid={buttonKey}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textTransform: 'none',
            fontSize: '0.875rem',
            padding: '6px 16px',
            minHeight: '36px',
            color: buttonKey === 'stopRecord' ? 'red' : buttonKey === 'record' ? 'green' : '', // Set text color for larger screens
            borderColor: buttonKey === 'stopRecord' ? 'red' : buttonKey === 'record' ? 'green' : '', // Set border color
            backgroundColor: isClicked ? 'rgba(211, 47, 47, 0.04)' : 'transparent',
            opacity: disabled ? 0.5 : 1,
            pointerEvents: disabled ? 'none' : 'auto',
            ...sx,
          }}
        >
          {t(text)}
        </Button>
      </Hidden>
      
      {/* Icon button for smaller screens */}
      <Hidden smUp>
        <IconButton
          color={color}
          disabled={disabled}
          onClick={handleClick}
          sx={{
            fontSize: '0.75rem',
            padding: '2px 6px',
            minHeight: '36px',
            minWidth: 'auto',
            border: isClicked ? '2px solid #1976d2' : 'none',
            backgroundColor: isClicked ? '#e3f2fd' : 'transparent',
            opacity: disabled ? 0.5 : 1,
            pointerEvents: disabled ? 'none' : 'auto',
            ...sx,
          }}
        >
          {renderIcon(buttonKey)}
        </IconButton>
      </Hidden>
    </>
  );
}